import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {Flow} from "../../../../flows/Flow.js";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {INLINE_EDIT_DONATION_URLS} from "../../../../PanelConstants";
import {PaymentMethodAcceptOrChange} from "../../payment-method/components/PaymentMethodAcceptOrChange.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {DonationStore} from "../../../../../../client/state/DonationStore";
import {BasePanelPage, BasePanelPageStyle} from "../../../../PanelPage";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {DonateComponent} from "../components/DonateComponent";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";


class EditDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    description = {
        display: "inline",
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    }
}

@autoredraw(PaymentMethodStore, DonationStore)
@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editDonationInlineTitle,
        };
    }

    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(Flow.donationDetails.isValid()
            && (Flow.donationDetails.donationAmount !== donation.computeAmount()
                || Flow.donationDetails.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== Flow.paymentMethod.selectedValue));
    }

    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        Flow.paymentMethod.init({
            entry: donation,
            savePaymentMethod: true,
            selectedValue: donation.getPaymentMethod(),
            continueLabel: Messages.updatePaymentMethod,
            scope: PaymentMethodStore.Scope.PRIVATE,
        });

        return [
            <div>
                <MessageElement
                    className={styleSheet.description}
                    message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}
                />
                <Link
                    value={Messages.here}
                    style={{display: "inline-block"}}
                    href={INLINE_EDIT_DONATION_URLS.cancel}
                />.
            </div>,

            !iFrameMerchantService.isCDSPaymentMethod() && <PaymentMethodAcceptOrChange style={{marginTop: 12, marginBottom: 12}} />,

            <DonateComponent
                ref="editDonationComponent"
                changeURL={this.options.changeURL}
                onChange={() => this.redraw()}
            />,

            <MerchantButton
                ref="button"
                label={Flow.donationDetails.getEditDonationComponentButtonLabel()}
                disabled={this.isButtonDisabled()}
                onClick={() => Flow.donation.updateDonation()}
                className={styleSheet.actionButton}
            />,
        ];
    }

    onMount() {
        super.onMount();

        this.redraw(); // We need this first redraw because we have interdependent components
    }
}
